import type { InputHTMLAttributes, ReactNode } from "react";

import { errorMessage } from "@/lib/api";

const paths: Record<string, string> = {
  cart: "M3 3h2l3 12h11l3-9H6m2 9-1 3h13M9 21h.01M18 21h.01",
  search: "m21 21-4.8-4.8M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
  heart: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8",
  arrow: "M4 12h16m-6-6 6 6-6 6",
  chevron: "m9 5 7 7-7 7",
  close: "m6 6 12 12M6 18 18 6",
  plus: "M12 5v14M5 12h14",
  user: "M20 21v-2a7 7 0 0 0-14 0v2M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
  check: "m5 12 4 4L19 6",
  pin: "M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  shield: "m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6l8-3m-4 9 3 3 5-6",
  leaf: "M20 4C8 2 2 9 6 16s16 3 14-12M4 21 16 9",
  upload: "M12 16V3m-5 5 5-5 5 5M4 15v5h16v-5",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9m-9 12h6",
  menu: "M4 6h16M4 12h16M4 18h16",
  phone: "m5 3 4 1 1 5-2 2 5 5 2-2 5 1 1 4c-2 5-10 0-14-4S1 5 5 3",
  share: "M16 6 8 10m0 4 8 4M21 4a3 3 0 1 1-6 0 3 3 0 0 1 6 0M9 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0M21 20a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  eye: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12m13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  logout: "M9 4H4v16h5m5-4 4-4-4-4m-6 4h12",
};

export function Icon({ name, size = 20 }: { name: string; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={paths[name] ?? paths.arrow} />
  </svg>;
}

export function Field({ label, children, hint }: { label: string; children: ReactNode; hint?: string }) {
  return <label className="field"><span className="field-label">{label}</span>{children}
    {hint && <span className="field-hint">{hint}</span>}</label>;
}

export function Input(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input className="input" {...props} />;
}

export function ErrorNotice({ error }: { error: unknown }) {
  return error ? <div role="alert" className="notice error">{errorMessage(error)}</div> : null;
}

export function Loading({ label = "Un instant, nous préparons votre sélection…" }: { label?: string }) {
  return <div className="loading" role="status"><span className="spinner" />{label}</div>;
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return <div className="empty"><span className="empty-mark">r.</span><h2>{title}</h2>{children}</div>;
}

export function Status({ value, label }: { value: string; label: string }) {
  return <span className={"status status-" + value}>{label}</span>;
}
